import {useState, useEffect, useRef} from "react";
import {useSelector, useSessionActions} from "../shared-services/redux-tiny";

function useBadges() {
  const currentUser = useSelector(state => state.session.currentUser);
  const {setCurrentUser} = useSessionActions();
  const [badges, setBadges] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const badgesRef = useRef();

  useEffect(() => {
    if (!currentUser || !badgesRef?.current) {
      return;
    }

    setIsLoading(false);
    const newBadges = [];
    const {ff_subscriber, smartPass, roles} = currentUser;
    const isCrowdInvestor = roles?.includes("crowd_investor");

    if (ff_subscriber && currentUser.canSeeFarmyFamily) {
      newBadges.push({
        name: "family",
        class: "badge-farmy-family",
        link: "/account/#farmy_family"
      });
    }

    if (smartPass && currentUser.hasActiveSubscription) {
      newBadges.push({
        name: "farmypass",
        class: "badge-farmypass",
        link: "/account#farmypass_preferences"
      });
    }

    if (isCrowdInvestor) {
      newBadges.push({
        name: "investor",
        class: "badge-investor",
        link: ""
      });
    }

    setBadges(newBadges);
    setIsDataLoaded(true);
  }, [currentUser]);

  useEffect(() => {
    if (!currentUser?.id || !badgesRef?.current) return;

    if (!isDataLoaded && window.SmartPassService && window.UserService && window.UserService.isLoggedIn) {
      window.SmartPassService.loadSubscriptions()
        .then(() => {
          if (!badgesRef?.current) return;
          
          setIsDataLoaded(true);
          const updatedSmartPassData = {
            hasActiveSubscription: window.SmartPassService.hasActiveSubscription,
            smartPass: {
              type: window.currentSmartPassType,
              level: window.currentSmartPassLevel,
              until: window.currentSmartPassUntilDate
            }
          };

          const updatedCurrentUser = {
            ...currentUser,
            ...updatedSmartPassData
          };
          setCurrentUser(updatedCurrentUser);
        })
        .catch(error => console.error("Error loading SmartPass:", error));
    }
  }, [isDataLoaded, currentUser, setCurrentUser]);

  useEffect(() => {
    badgesRef.current = true;

    return () => {
      badgesRef.current = false;
    };
  }, []);

  return [badges, isLoading];
}

export default useBadges;
